module.exports = __webpack_public_path__ + "static/media/img-feature.37fef9b2.jpg";